import { useState } from 'react'
import type { FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'

function ForgotPasswordPage() {
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(
    event: FormEvent<HTMLFormElement>,
  ) {
    event.preventDefault()

    setMessage('')
    setError('')
    setLoading(true)

    try {
      const response = await fetch(
        '/api/auth/forgot-password',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email.trim(),
          }),
        },
      )

      const data = await response.json()

      if (!response.ok) {
        setError(
          typeof data.detail === 'string'
            ? data.detail
            : 'Unable to send password reset email.',
        )
        return
      }

      setMessage(
        data.message ||
          'If an account exists, a password reset link has been sent.',
      )
    } catch {
      setError(
        'Unable to connect to the server. Please try again.',
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <main>
      <section>
        <h1>Forgot your password?</h1>

        <p>
          Enter your email address and we will send you a
          password reset link.
        </p>

        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email">
              Email address
            </label>

            <input
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(event) =>
                setEmail(event.target.value)
              }
              autoComplete="email"
              required
            />
          </div>

          {error && (
            <p role="alert">
              {error}
            </p>
          )}

          {message && (
            <p>
              {message}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
          >
            {loading
              ? 'Sending...'
              : 'Send reset link'}
          </button>
        </form>

        <button
          type="button"
          onClick={() => navigate('/login')}
        >
          Back to sign in
        </button>
      </section>
    </main>
  )
}

export default ForgotPasswordPage